import React, { useState, useEffect } from 'react'
import {
    Box,
    Text,

    /* Hooks */
    useMultiStyleConfig,
    useBreakpointValue
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
} from '@chakra-ui/react'
import { FormattedMessage } from 'react-intl'

/* Styles */
import { StoreLocatorStylesProvider } from './styles/storeLocatorStyles'

/* Components */
import StoreLocatorMap from './partials/store-locator-map'
import StoreLocatorInput from './partials/store-locator-input'
import StoreLocatorNoResults from './partials/store-locator-no-results'
import StoreLocatorStoreList from './partials/store-locator-store-list'
import StoreLocatorDetails from './partials/store-locator-details'
import StoreLocatorInfo from './partials/store-locator-info'

/* Context */
import { useStoreLocator } from '../../contexts/store-locator-context';

const StoreLocatorContent = ({

}) => {
    const styles = useMultiStyleConfig('StoreLocator', {})
    const [mounted, setMounted] = useState(false);
    const isMobile = useBreakpointValue({ base: true, lg: false })
    const {
        setPermissionStatus,
        setGeolocationLoading,
        getLocation
    } = useStoreLocator()

    useEffect(() => {
        setMounted(true);
        if (navigator.permissions) {
            navigator.permissions.query({ name: 'geolocation' }).then((status) => {
                getLocation()
                setPermissionStatus(status.state)

                status.onchange = () => {
                    setPermissionStatus(status.state)
                    if (status.state === 'granted') {
                        getLocation()
                    }
                };
            });
        } else {
            setPermissionStatus('prompt')
            setGeolocationLoading(false)
        }
    }, []);

    if (!mounted) {
        return null;
    }

    return (
        <StoreLocatorStylesProvider value={styles}>
            <Box  {...styles.container} data-testid="store-locator-container">
                {/* Page heading */}
                <Text as="h1" {...styles.heading} {...styles.contentWrapper}>
                    <FormattedMessage
                        id="store_locator.heading"
                        defaultMessage="Store locator"
                    />
                </Text>

                {/* Mobile layout */}
                {isMobile &&
                    <Box>
                        <Box {...styles.contentWrapper}>
                            <StoreLocatorInput />
                            <StoreLocatorNoResults />
                        </Box>
                        <Tabs>
                            <TabList>
                                <Tab {...styles.tab}>
                                    <FormattedMessage
                                        id="store_locator.tab.list"
                                        defaultMessage="List"
                                    />
                                </Tab>
                                <Tab {...styles.tab}>
                                    <FormattedMessage
                                        id="store_locator.tab.map"
                                        defaultMessage="Map"
                                    />
                                </Tab>
                            </TabList>

                            <TabPanels>
                                <TabPanel {...styles.storesTabPanel}>
                                    <StoreLocatorStoreList />
                                </TabPanel>
                                <TabPanel {...styles.mapTabPanel}>
                                    <StoreLocatorMap />
                                    <StoreLocatorInfo />
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    </Box>
                }

                {/* Desktop layout */}
                {!isMobile &&
                    <Box {...styles.desktopLayout}>
                        <Box {...styles.mapContainer}>
                            <StoreLocatorMap />
                        </Box>
                        <Box {...styles.storesContainer}>
                            <Box {...styles.inputAndNoStores}>
                                <StoreLocatorInput />
                                <StoreLocatorNoResults />
                            </Box>
                            <Box {...styles.storeListWrapper}>
                                <StoreLocatorStoreList />
                            </Box>
                        </Box>
                    </Box>
                }

                {/* Store details drawer */}
                <StoreLocatorDetails />
            </Box>
        </StoreLocatorStylesProvider>
    )
}

export default StoreLocatorContent
